import React from 'react';

import classes from '../installPics.css';

import CorrugatedImg2 from '../../../../../../../assets/CorrugatedImg2.JPG';

const CorrugatedPic2
 = () => (
     <div className={classes.installImages}>
         <img alt="22kW residential installation in New Jersey" src={CorrugatedImg2} className={classes.installImg} />
     </div>
 );


export default CorrugatedPic2;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/CorrugatedMetal/CorrugatedImg2.js